function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="22" viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg" {...props}><title>calendar</title><g fill="#A8ACBB" fillRule="nonzero"><path d="M3 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3zm0-2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3z" /><path d="M13 1a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0V1zM5 1a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V1zM1 10a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2H1z" /></g></svg>;
});